import { useGetCurrentBoard } from 'entities/board/api/hooks/useGetCurrentBoard';
import { getHasHateoasAccess } from 'helpers';

export const useCanManageCompanies = () => {
  const { board } = useGetCurrentBoard();

  return getHasHateoasAccess('companies', board?.__links);
};
